import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetRecentView = createAsyncThunk(
  "viewData/getRecentView",
  async (_, thunkAPI) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("authToken");


      const response = await axios.get(endPoint.GETRECENTVIEW, {
        params: {
          sessionId: storedUuid ? storedUuid : "",
        },
        headers: {
          Authorization: Token ? `Bearer ${Token}` : "",
        },
      });


      if (response.data.recentlyViewedProducts.length === 0) {
        console.log("No products found for this session");
      } else {
        console.log(
          "Recently viewed products:",
          response.data.recentlyViewedProducts
        );
      }

      return response.data;
    } catch (error) {
      console.error("Error in fetching recent views:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetRecentViewSlice = createSlice({
  name: "GetRecentData",
  initialState: {
    GetRecentData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetRecentView.fulfilled, (state, action) => {
        state.GetRecentData = action.payload;
      })
      .addCase(GetRecentView.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetRecentViewSlice.reducer;
